import React from 'react'
import { createPortal } from 'react-dom'

import DatePicker from '../DatePicker/DatePicker'

interface EducationPortalsProps {
  datePickerState: {
    educationId: string
    field: 'startDate' | 'endDate'
    position: { top: number; left: number; width: number }
    triggerKey: string
  } | null
  datePickerRef: React.RefObject<HTMLDivElement>
  editingStartDate: string
  editingEndDate: string
  onDateChange: (value: string) => void
  onClose: () => void
}

export default function EducationPortals({
  datePickerState,
  datePickerRef,
  editingStartDate,
  editingEndDate,
  onDateChange,
  onClose,
}: EducationPortalsProps) {
  if (!datePickerState) return null

  return createPortal(
    <DatePicker
      ref={datePickerRef}
      value={datePickerState.field === 'startDate' ? editingStartDate : editingEndDate}
      onChange={onDateChange}
      onClose={onClose}
      position={datePickerState.position}
      monthYearOnly={true}
      allowPresent={false}
    />,
    document.body,
  )
}
